import { useMemo, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { NsContent } from 'components/common/ns-content/NsContent';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsCard } from 'components/common/ns-card/NsCard';
import { NsStopgap } from 'components/common/ns-stopgap/NsStopgap';
import { NsxAddressSelector } from 'components/common/nsx-address-selector/NsxAddressSelector';

import { useNavigation } from 'hooks/useNavigation';
import { selectors as meterTypeSelectors } from 'state/meter-type/meter-type-slice';

const { selectIsLoading: selectIsLoadingMeterType } = meterTypeSelectors;

export const testId = 'quoteExpiredTestId';

export const QuoteExpiredContent = () => {
  const isLoadingMeterType = useSelector(
    selectIsLoadingMeterType,
    shallowEqual
  );
  const { next, eventTypes } = useNavigation();

  const handleGoNext = useCallback(() => {
    next({ eventType: eventTypes.NEXT });
  }, [next, eventTypes.NEXT]);

  return useMemo(() => {
    if (isLoadingMeterType) {
      return <NsStopgap />;
    }

    return (
      <>
        <NsContent>
          <NsTitle title="This link has expired" />
          <p>It only takes a minute to get a new quote.</p>
        </NsContent>
        <NsCard>
          <NsxAddressSelector handleGoNext={handleGoNext} />
        </NsCard>
      </>
    );
  }, [handleGoNext, isLoadingMeterType]);
};

export default QuoteExpiredContent;
